<article class="notification-item" [class.delivery-failed]="deliveryFailed()">
  <div class="type-icon">
    <mat-icon aria-hidden="true">{{ presentation().icon }}</mat-icon>
  </div>
  <div class="notification-item-content">
    <div class="item-heading">
      <h3>{{ presentation().title }}</h3>
      @if (notification().createdAt; as createdAt) {
        <time
          [attr.datetime]="createdAt"
          [matTooltip]="(createdAt | date: 'medium') ?? ''"
          >{{ createdAt | date: "short" }}</time
        >
      }
    </div>
    @if (notification().context?.subject; as subject) {
      <p class="subject">{{ subject }}</p>
    }
    <p class="description">{{ text() }}</p>
    @if (referenceLink(); as link) {
      <a
        class="reference-link"
        [routerLink]="link.url"
        (click)="onNotificationReadClick()"
        >{{ link.label
        }}<mat-icon aria-hidden="true">arrow_outward</mat-icon></a
      >
    }
    @if (readFailed()) {
      <p class="read-error" role="alert" i18n="@@notificationReadError">
        Nicht als gelesen gespeichert. Bitte versuchen Sie es erneut.
      </p>
    }
  </div>
  <button
    class="read-action"
    mat-icon-button
    type="button"
    [matTooltip]="markAsReadTooltip"
    [attr.aria-label]="markAsReadTooltip"
    [disabled]="markingAsRead()"
    (click)="onNotificationReadClick()"
  >
    <mat-icon>{{
      markingAsRead() ? "check_circle" : "check_circle_outline"
    }}</mat-icon>
  </button>
</article>
